
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Pimplesaudagartomumbaicab() {



    const cardData =
    {
        keyword: 'Pimple Saudagar to Mumbai Cab  ',
        heading: 'Vedant Travels: Pimple Saudagar to Mumbai Cab  ',
        headingDescription: 'Vedant Travels offers affordable and transparent taxi fares for Pimple Saudagar to Mumbai travel, ensuring a cost-effective and comfortable journey. Our pricing is competitive, with no hidden charges, and we provide multiple cab options to suit your budget and preferences.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
        {
            "title": "Gateway of India",
            "description": "One of Mumbai’s most iconic landmarks, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this magnificent structure is a favorite among tourists for sightseeing and photography. You can also take a ferry from here to visit Elephanta Caves."
        },
        {
            "title": "Marine Drive",
            "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coastline of Mumbai. It’s the perfect spot for an evening stroll, enjoying the sea breeze, or watching the sunset. At night, the streetlights form a stunning arc that resembles a necklace, making it one of the most picturesque locations in Mumbai."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and feature ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th–7th centuries and are known for their intricate sculptures and carvings. A ferry ride from the Gateway of India takes you to this historical site, offering a blend of nature, history, and spirituality."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A masterpiece of Victorian Gothic architecture, CSMT is not just a railway station but a UNESCO-listed historic site. The station, formerly known as Victoria Terminus, features grand turrets, stained glass windows, and intricate stone carvings, showcasing the colonial-era grandeur of Mumbai."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of the most revered Hindu temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees visit the temple daily to seek blessings, including Bollywood celebrities and politicians. The temple’s beautiful architecture and spiritual ambiance make it a must-visit."
        },
        {
            "title": "Juhu Beach",
            "description": "Juhu Beach is among the most famous beaches in Mumbai, known for its lively atmosphere and delicious street food. Whether you want to relax by the sea, take a camel ride, or try local delicacies like pav bhaji, vada pav, and bhel puri, this beach has something for everyone. It's also a popular spot for catching a mesmerizing sunset."
        },
        {
            "title": "Colaba Causeway",
            "description": "If you love shopping, Colaba Causeway is the place to be. This bustling street market is filled with stalls selling jewelry, handicrafts, clothes, antiques, and souvenirs. Besides shopping, you can also explore the charming cafés and restaurants in the area, such as Leopold Café, a historic eatery loved by tourists."
        },
        {
            "title": "Haji Ali Dargah",
            "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a significant religious and architectural landmark in Mumbai. This Indo-Islamic shrine is dedicated to the Sufi saint Haji Ali and is accessible via a narrow causeway that gets submerged during high tide. The dargah’s serene atmosphere and breathtaking views make it a must-visit destination."
        },
        {
            "title": "Bandra-Worli Sea Link",
            "description": "An architectural marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai to the suburbs. The cable-stayed bridge offers spectacular views of the Arabian Sea and Mumbai’s skyline, especially when illuminated at night. It significantly reduces travel time between Bandra and Worli, making it a vital part of Mumbai’s infrastructure."
        },
        {
            "title": "Bollywood Film City",
            "description": "Mumbai is the heart of the Indian film industry, and Film City in Goregaon offers visitors a chance to witness Bollywood magic up close. With multiple studios, sets, and backdrops, Film City is where countless Bollywood movies and TV shows are filmed. Guided tours provide an exclusive behind-the-scenes look at Mumbai’s thriving cinema industry, making it a must-visit for movie buffs."
        }
    ],


"services": [
    {
        "name": "Pimple Saudagar to Mumbai Cab",
        "description": "Traveling from Pimple Saudagar to Mumbai? Vedant Travels provides reliable and comfortable taxi services. Whether it’s a business trip, family outing, or leisure journey, our professional drivers ensure a smooth ride."
    },
    {
        "name": "Pimple Saudagar to Mumbai Airport Cab",
        "description": "Book your ride from Pimple Saudagar to Mumbai Airport with Vedant Travels. We offer punctual and comfortable airport transfers to ensure you never miss your flight."
    },
    {
        "name": "Pimple Saudagar to Mumbai International Airport",
        "description": "For a stress-free journey from Pimple Saudagar to Mumbai International Airport, choose Vedant Travels. Our fleet includes well-maintained vehicles and experienced drivers for a safe and comfortable ride."
    },
    {
        "name": "Pimple Gurav to Mumbai Cab Service",
        "description": "If you're in Pimple Gurav, choose Vedant Travels for your ride to Mumbai. Our services are available at affordable rates, with professional drivers to ensure a pleasant trip."
    },
    {
        "name": "Taxi Service in Pimple Gurav",
        "description": "Looking for reliable taxi services in Pimple Gurav? Vedant Travels offers comfortable and affordable taxis to suit your needs, whether it’s for a short trip or a longer journey."
    },
    {
        "name": "Taxi Service in Pimple Saudagar, Pune",
        "description": "Vedant Travels provides dependable taxi services in Pimple Saudagar, Pune. Whether you're heading to the airport or Mumbai, our taxi service is here to make your travel experience smooth and comfortable."
    },
    {
        "name": "Pune to Mumbai Airport Cab",
        "description": "For easy and affordable transportation from Pune to Mumbai Airport, Vedant Travels offers prompt and reliable airport cab services. We ensure timely arrival at the airport for a stress-free experience."
    },
    {
        "name": "Pune to Mumbai Ertiga Cab",
        "description": "Traveling with a family or a group? The Ertiga cab is perfect for your journey from Pune to Mumbai. Spacious and comfortable, the Ertiga is available for your travel needs."
    },
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "For a more premium and comfortable ride from Pune to Mumbai, Vedant Travels offers the Innova cab. Ideal for business or family travel, it ensures extra comfort and space."
    },
    {
        "name": "Top-Rated Mumbai to Pimple Saudagar Cabs",
        "description": "Vedant Travels offers top-rated taxi services for your journey from Mumbai to Pimple Saudagar. Our services are trusted for comfort, safety, and reliability."
    },
    {
        "name": "Pimple Saudagar to Dadar Cab Service",
        "description": "For a smooth ride from Pimple Saudagar to Dadar, choose Vedant Travels. We provide affordable, timely, and comfortable taxi services to Dadar and other locations."
    },
    {
        "name": "Pimple Gurav to Dadar Cab Service",
        "description": "Traveling from Pimple Gurav to Dadar? Vedant Travels offers convenient and reliable cab services. Our experienced drivers ensure a hassle-free and comfortable journey."
    },
    {
        "name": "Cab Service in Pimple Gurav",
        "description": "Vedant Travels provides cab services in Pimple Gurav, Pune. Whether you need a ride to Mumbai or just around the city, we ensure comfort and timely service."
    },
    {
        "name": "Taxi Service in Pimple Saudagar, Pune",
        "description": "For your taxi needs in Pimple Saudagar, Pune, Vedant Travels offers reliable and affordable taxi services for all destinations. Book your ride today for a seamless experience."
    },
    {
        "name": "Innova Crysta on Rent in Pimple Saudagar, Pune",
        "description": "Looking for a luxurious ride? Rent an Innova Crysta with Vedant Travels for your journey from Pimple Saudagar. Enjoy comfort and style on your trip."
    },
    {
        "name": "Pimple Saudagar to Andheri Cab",
        "description": "Need a taxi from Pimple Saudagar to Andheri? Vedant Travels offers affordable, reliable, and timely cabs for your convenience. Book your ride today!"
    },
    {
        "name": "Pune to Mumbai Cab Round Trip",
        "description": "For a round-trip journey from Pune to Mumbai, Vedant Travels offers flexible booking options. Enjoy a comfortable and hassle-free ride with experienced drivers."
    },
    {
        "name": "Ertiga on Rent in Pimple Saudagar",
        "description": "Rent the Ertiga for your next trip from Pimple Saudagar. Whether you’re traveling with family or friends, the Ertiga offers spacious and comfortable travel."
    },
    {
        "name": "Cab Service in Pune",
        "description": "Vedant Travels offers reliable and affordable cab services in Pune. From local travel to long-distance journeys, we ensure a smooth and comfortable experience."
    },
    {
        "name": "Pune to Mumbai Cab",
        "description": "Choose Vedant Travels for your Pune to Mumbai journey. We provide reliable, comfortable, and affordable taxi services to make your trip enjoyable and stress-free."
    },
    {
        "name": "Contact Information",
        "description": "For bookings and inquiries, contact Vedant Travels at +91 8767459909. We offer dependable and comfortable taxi services for all your travel needs, including trips from Pimple Saudagar to Mumbai, Mumbai Airport, and beyond."
    }
],


 "tableData": [
    ["Pimple Saudagar to Mumbai Cab", "pimple saudagar to mumbai airport cab"],
    ["pimple saudagar to mumbai international airport", "pimple gurav to mumbai cab service"],
    ["taxi service in pimple gurav", "taxi service in pimple saudagar pune"],
    ["pune to mumbai airport cab", "pune to mumbai ertiga cab"],
    ["Pune to Mumbai Innova Cab", "Top-rated Mumbai to Pimple Saudagar cabs"],
    ["pimple saudagar to dadar cab service", "pimple gurav to dadar cab service"],
    ["cab service in pimple gurav", "taxi service in pimple saudagar pune"]
],
"whychoose": [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Vedant Travels, we know that punctuality is key. Whether you're traveling for business or pleasure, our professional drivers ensure timely pickups and drop-offs between Pimple Saudagar and Mumbai, so you can stay on schedule without any stress."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We provide a variety of well-maintained, comfortable, and spacious vehicles for your journey from Pimple Saudagar to Mumbai. With features like air conditioning, ample legroom, and comfortable seating, your ride will be relaxing and enjoyable."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are skilled and experienced in handling long-distance routes like Pimple Saudagar to Mumbai. They are well-versed in the best routes to avoid traffic, ensuring a safe, smooth, and timely journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Vedant Travels offers competitive rates with no hidden charges. We believe in transparent pricing, so you know exactly what you're paying for when you book your Pimple Saudagar to Mumbai cab."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All of our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable journey from start to finish."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether it’s an early morning departure or a late-night arrival, Vedant Travels is available round-the-clock. You can book a cab at any time, and we’ll be ready to provide you with a hassle-free ride."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a cab from Pimple Saudagar to Mumbai is quick and easy. You can book your ride online through our website or mobile app, or contact our customer service team for assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling for business, leisure, or any special occasion, we offer customized travel packages to meet your needs. Share your preferences, and we'll tailor the journey to ensure maximum comfort and convenience."
    }
]

    








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pimple Saudagar to Mumbai cab with Vedant Travels?',
            answer: 'You can book a cab online via our website or mobile app. Alternatively, feel free to contact our customer service team for help with your booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are trained and experienced in long-distance routes like Pimple Saudagar to Mumbai. They ensure a safe and smooth journey for you.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Pimple Saudagar to Mumbai travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars. All of our vehicles are spacious, well-maintained, and equipped for comfort.',
        },
        {
            id: 4,
            question: 'How do I pay for my Pimple Saudagar to Mumbai cab rental?',
            answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payments via our app, offering you flexibility in how you pay for your ride.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Pimple Saudagar to Mumbai?',
            answer: 'Yes, round-trip bookings are available. Simply provide your return details when booking, and we’ll arrange the return journey as well.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges for waiting time or detours will be clearly communicated to you upfront, ensuring there are no hidden fees or surprises.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mumbai after my drop-off?',
            answer: 'Yes, we offer sightseeing tours in Mumbai. Visit popular spots like the Gateway of India, Marine Drive, and more with a trusted driver guiding you through the city.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Pimple Saudagar to Mumbai cab?',
            answer: 'Our vehicles can accommodate standard luggage. If you have more luggage or specific needs, please inform us at the time of booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Pimple Saudagar and Mumbai?',
            answer: 'Yes, we offer corporate travel services, including business meetings, airport transfers, and team outings. Contact us for customized corporate packages designed to meet your company’s travel needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Pimple Saudagar to Mumbai journey?',
            answer: 'Vedant Travels offers reliable, comfortable, and affordable travel services with professional drivers, modern vehicles, and a focus on customer satisfaction. We ensure a safe and stress-free journey from Pimple Saudagar to Mumbai.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Raghav Kulkarni",
            title: "Customer",
            quote: "I had a wonderful experience with Vedant Travels while traveling from Pimple Saudagar to Mumbai. The driver was professional, the vehicle was clean and comfortable, and the journey was smooth. Highly recommend!",
            rating: 5,
        },
        {
            name: "Mrs. Shilpa Agrawal",
            title: "Customer",
            quote: "We booked a cab with Vedant Travels for a family trip from Pimple Saudagar to Mumbai. The vehicle was spacious, and the driver was courteous. The entire experience was seamless, and we will definitely use their services again.",
            rating: 5,
        },
    ];
    
    
    
    












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimple Saudagar to Mumbai Cab | Vedant Travels",
  "image": "https://www.vedanttravels.in/images/pimple-saudagar-to-mumbai-cab.jpg",
  "description": "Book your Pimple Saudagar to Mumbai cab with Vedant Travels for an affordable, smooth, and reliable journey. Get one-way, airport drop, or round-trip cabs in Innova Crysta, Ertiga, Swift Dzire, or Sedan. Experience timely pickups and courteous drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "reviewCount": "4560",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.vedanttravels.in/pimple-saudagar-to-mumbai-cab",
    "validFrom": "2025-08-01"
  },
  "areaServed": {
    "@type": "Place",
    "name": ["Pimple Saudagar", "Pune", "Mumbai", "Mumbai Airport", "Bandra", "Andheri", "Dadar", "Borivali"]
  }
};


      
    



    return (
        <div>
           
         <Helmet>
  <title>Pimple Saudagar to Mumbai Cab – Affordable One Way & Airport | Vedant Travels</title>
  <meta
    name="description"
    content="Book Pimple Saudagar to Mumbai cab with Vedant Travels. Enjoy clean cabs, timely airport drops, and low fares in Innova Crysta, Ertiga, or Sedan. One-way, round-trip, and 24/7 booking available."
  />
  <meta
    name="keywords"
    content="Pimple Saudagar to Mumbai Cab, Cab from Pimple Saudagar to Mumbai Airport, One Way Taxi Pimple Saudagar to Mumbai, Pimple Saudagar to Bandra Drop, Innova Crysta Cab Pimple Saudagar to Mumbai, Ertiga Cab Pimple Saudagar to Mumbai, Vedant Travels Pimple Saudagar Cabs, Pimple Saudagar to Dadar Cab, Pimple Saudagar to Andheri Taxi"
  />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.vedanttravels.in/pimple-saudagar-to-mumbai-cab" />
  <script type="application/ld+json">{JSON.stringify(jsonData)}</script>
</Helmet>

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pimplesaudagartomumbaicab;